import React from 'react';
import Input from '../../../Components/Input';
import ActionSelector from '../ActionSelector';
import DimensionSelector from '../DimensionSelector';
import MediaSelector from '../MediaSelector';
import PositionSelector from '../PositionSelector';
import { BuilderActionType, BuilderContext } from '../state';
import VendexElement, { VendexImageMeta } from '../../../Model/VendexElement';
import VendexAction from '../../../Model/VendexAction';
import Select from '../../../Components/Select';
import { BuilderField, BuilderFieldGrid } from '../BuilderFields';

type Props = {
    element: VendexElement;
};

function ImageDetail({ element }: Props) {
    const data = element.metaData as VendexImageMeta;

    const { dispatch } = React.useContext(BuilderContext);

    const handleChange = (value: VendexElement) => {
        dispatch({
            type: BuilderActionType.UPDATE_ELEMENT,
            payload: value,
        });
    };

    const handleDataChange = (name: string, value: string) => {
        handleChange({
            ...element,
            metaData: { ...data, [name]: value },
        });
    };

    const handleActionChange = (actions: VendexAction[]) => {
        handleChange({
            ...element,
            actions,
        });
    };

    return (
        <>
            <BuilderFieldGrid>
                <BuilderField label="Type">
                    <Select
                        onChange={(e) => {
                            handleDataChange('type', e.target.value);
                        }}
                        value={data.type}
                    >
                        <option value="STATIC">STATIC</option>
                        <option value="DYNAMIC">DYNAMIC</option>
                    </Select>
                </BuilderField>
                <BuilderField
                    label="Source"
                    helperText={
                        data.type === 'STATIC'
                            ? 'Choose an uploaded image asset.'
                            : 'Provide the dynamic data key to resolve at runtime.'
                    }
                >
                    {data.type === 'STATIC' ? (
                        <MediaSelector
                            url={data.source}
                            onChange={(value) =>
                                handleDataChange('source', value)
                            }
                            type="IMAGE"
                        />
                    ) : (
                        <Input
                            value={data.source}
                            onChange={(e) =>
                                handleDataChange('source', e.target.value)
                            }
                        />
                    )}
                </BuilderField>
            </BuilderFieldGrid>
            <PositionSelector selector={`#${element.id}`} />
            <DimensionSelector selector={`#${element.id}`} />
            <ActionSelector
                actions={element.actions}
                onChange={handleActionChange}
            />
        </>
    );
}

export default ImageDetail;
